var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgInstagram = function SvgInstagram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 26 26",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 0C5.82 0 0 5.82 0 13s5.82 13 13 13 13-5.82 13-13S20.18 0 13 0zM6.5 10.11A3.611 3.611 0 0110.111 6.5h5.778A3.612 3.612 0 0119.5 10.11v5.778a3.611 3.611 0 01-3.611 3.611H10.11A3.611 3.611 0 016.5 15.888V10.11zm11.556-1.444a.723.723 0 10-1.445 0 .723.723 0 001.445 0zm-1.445 4.333a3.611 3.611 0 10-7.223 0 3.611 3.611 0 007.223 0zm-5.143-1.532a2.167 2.167 0 113.064 3.064 2.167 2.167 0 01-3.064-3.064z"
  })));
};
export default SvgInstagram;